import store from '@/stores/index'
import useragent from '@finance/useragent'
/**
 * @methods 获取通知栏参数
 */
export const getDeviceNotchParams = () => {
  return new Promise((resolve) => {
    if (!useragent.isKaniu) {
      console.warn('getDeviceNotchParams:不在随手记app')
      resolve({ hasNotch: true, notchHeight: 102 })
      return
    }
    window.sui.ready(() => {
      try {
        window.sui.getDeviceNotchParams({
          success(res: any) {
            console.log('getDeviceNotchParams', res)
            resolve(JSON.parse(res.result))
          },
          error(err: any) {
            console.warn('getDeviceNotchParams err', err)
            resolve({ hasNotch: true, notchHeight: 112 })
          },
        })
      } catch (e) {
        console.error(`window.sui.getDeviceNotchParams ${window.sui.getDeviceNotchParams} `, e)
      }
    })
  })
}

export const getClientInfo = (requestInfo: string[]) => {
  return new Promise((resolve, reject) => {
    if (!useragent.isSuishouji && !useragent.isKaniu) {
      console.warn('getClientInfo:不在随手记app')
      resolve(null)
      return
    }
    window.sui.ready(() => {
      window.sui.getClientInfo({
        requestInfo,
        success: async(res: any) => {
          if (res.code !== 0) {
            reject(new Error(res.message || '获取信息失败'))
            return
          }
          if (useragent.isKaniu && useragent.isAndroid) {
            getDeviceNotchParams().then((info: any) => {
              const { hasNotch, notchHeight } = info
              if (hasNotch) {
                const barHeight = (notchHeight - 20) * window.devicePixelRatio
                res.result.phoneInfo.result.toolBarHeight = barHeight
              } else {
                res.result.phoneInfo.result.toolBarHeight = 219
              }
              resolve(res.result)
            })
          } else if (useragent.isKaniu) {
            const saveTop = getComputedStyle(document.documentElement).getPropertyValue('--sat')
            const saveTopNum = Number(saveTop.replace('px', ''))
            res.result.phoneInfo.result.toolBarHeight = (44 + saveTopNum) * window.devicePixelRatio
            console.log('??saveTopNum', saveTopNum)
            resolve(res.result)
          } else {
            resolve(res.result)
          }
        },
        error: () => {
          reject(new Error('获取信息失败'))
        }
      })
    })
  })
}

/**
 * 获取手机信息
 */
export const getPhoneInfo = () => {
  return new Promise((resolve, reject) => {
    getClientInfo(['phoneInfo']).then((res: any) => {
      if (res && res.phoneInfo && res.phoneInfo.code === 0) {
        resolve(res.phoneInfo.result)
        return
      }
      reject(new Error('获取手机信息失败'))
    }).catch((e) => {
      reject(e)
    })
  })
}

/**
 * 获取用户信息
 */
export const getUserInfo = () => {
  return new Promise((resolve, reject) => {
    getClientInfo(['userInfo']).then((res: any) => {
      if (res && res.userInfo && res.userInfo.code === 0) {
        resolve(res.userInfo.result)
        return
      }
      reject(new Error('获取用户信息失败'))
    }).catch((e) => {
      reject(e)
    })
  })
}

export const requestHWPay = (info: any) => {
  return new Promise((resolve, reject) => {
    if (!useragent.isSuishouji) {
      reject(new Error('不在随手记app，获取信息失败'))
      return
    }
    window.sui.ready(() => {
      console.info('huaweipay: requestHWPay param:', info)
      window.sui.requestHWPay({
        ...info,
        success: (res: any) => {
          if (res.code !== 0) {
            reject(res.message || '支付服务异常')
            return
          }
          resolve(res.result)
        },
        error: (e: any) => {
          if (e && e.msg === 'Api apply timeout') {
            console.log(e.msg)
          } else {
            reject(e ? (e.msg || '支付服务异常') : '支付服务异常')
          }
        }
      })
    })
  })
}

export const callInAppPurchase = (info: any) => {
  return new Promise((resolve, reject) => {
    if (!useragent.isSuishouji) {
      reject(new Error('不在随手记app，获取信息失败'))
      return
    }
    window.sui.ready(() => {
      console.info('applepay: callInAppPurchase param:', info)
      window.sui.callInAppPurchase({
        ...info,
        success: (res: any) => {
          console.info('applepay: success:', res)
          if (res.code !== 0) {
            reject(res.message || '支付服务异常')
            return
          }
          resolve(res.result)
        },
        error: (e: any) => {
          if (e && e.msg === 'Api apply timeout') {
            console.log(e.msg)
          } else {
            reject(e ? (e.msg || '支付服务异常') : '支付服务异常')
          }
        }
      })
    })
  })
}

/**
 * 开启关闭页面弹性效果
 */
export const closeWebViewBounce = () => {
  return new Promise<void>((resolve, reject) => {
    if (!useragent.isSuishouji) {
      console.warn('closeWebViewBounce:不在随手记app')
      resolve()
      return
    }
    window.sui.ready(() => {
      window.sui.enableWebViewBounce({
        enable: false, // 是否开启
        success: () => {
          console.log('关闭回弹成功')
          resolve()
        },
        error: () => {
          console.log('关闭回弹失败')
          reject()
        }
      })
      // window.sui.enablePullRefresh({
      //   enable: false, // 是否开启
      //   success: () => {
      //     console.log('关闭刷新成功')
      //     resolve()
      //   },
      //   error: () => {
      //     console.log('关闭刷新失败')
      //     reject()
      //   }
      // })
    })
  })
}

/**
 * 下载文件
 */
export const downloadImage = (url: string) => {
  return new Promise((resolve, reject) => {
    window.sui.ready(() => {
      window.sui.downloadImage({
        imageUrl: url,
        waitUserAction: true,
        success() {
          console.log('下载成功')
          resolve(true)
        },
        error(e: any) {
          console.log('下载失败')
          reject(e)
        }
      })
    })
  })
}

/**
 * 获取用户当前账本信息
 */
export const queryUserCurrentAccountBookInfo = () => {
  return new Promise((resolve, reject) => {
    if (!useragent.isSuishouji) {
      console.warn('queryUserCurrentAccountBookInfo:不在随手记app')
      resolve(null)
      return
    }
    window.sui.ready(() => {
      window.sui.queryUserCurrentAccountBookInfo({
        success(res: any) {
          console.log('获取用户当前账本信息成功')
          resolve(res)
        },
        error(e: any) {
          console.log('获取用户当前账本信息失败')
          reject(e)
        }
      })
    })
  })
}

/**
 * @methods 获取用户消息中心信息
 */
export const getMessageCenterInfo = () => {
  return new Promise((resolve, reject) => {
    if (!useragent.isSuishouji) {
      console.warn('getMessageCenterInfo:不在随手记app')
      resolve(0)
      return
    }
    window.sui.ready(() => {
      try {
        window.sui.getMessageCenterInfo({
          success(res: any) {
            const unreadMessageCount = res.result.unreadMessageCount || 0
            store.commit('updateUnreadMessageCount', unreadMessageCount)
            resolve(unreadMessageCount)
          },
          error(err: any) {
            reject(err)
          },
        })
      } catch (e) {
        console.error(`window.sui.getMessageCenterInfo ${window.sui.getMessageCenterInfo} `, e)
      }
    })
  })
}

/**
 * 微信app支付
 */
export const requestWechatPrepay = (info: any, orderNo = '') => {
  return new Promise((resolve, reject) => {
    if (!useragent.isSuishouji && !useragent.isKaniu) {
      reject(new Error('不在随手记app，获取信息失败'))
      return
    }
    window.sui.ready(() => {
      console.info('requestWechatPrepay param:', info)
      window.sui.requestWechatPrepay({
        ...info,
        success: (res: any) => {
          console.log('??requestWechatPrepay', res)
          if (res.code !== 0) {
            reject(res || { msg: '支付服务异常' })
            return
          }
          resolve(res.result)
        },
        error: (err: any) => {
          err.orderNo = orderNo
          reject(err || { msg: '支付服务异常' })
        }
      })
    })
  })
}

export const getSupportAPIMap = (apiName: string) => {
  return new Promise((resolve, reject) => {
    if (!(useragent.isSuishouji || useragent.isKaniu)) {
      reject(new Error('不在随手记app，获取信息失败'))
      return
    }
    window.sui.ready(() => {
      window.sui.getSupportAPIMap({
        success: (res: any) => {
          console.log('getSupportAPIMap', res)
          const { authList } = res.result
          if (res.code !== 0) {
            reject(new Error(res.message || '查询支持接口失败'))
            return
          }
          if (authList && authList.includes(apiName)) {
            resolve(true)
          } else {
            resolve(false)
          }
        },
        error: () => {
          reject(new Error('查询支持接口失败'))
        }
      })
    })
  })
}

/**
 * 唤起登录获取用户信息
 * @param needLogin 1 唤起登录 5 只使用sms登录 6要求绑定手机号
 * @param showSkip  当 needLogin 为 5 / 6 时，是否展示跳过按钮
 */
export const loginByGetUserInfo = (parmas?: getUserInfoLogin) => {
  const { needLogin = 1, showSkip = 0 } = parmas || {}
  return new Promise((resolve, reject) => {
    if (!(useragent.isSuishouji || useragent.isKaniu)) {
      reject(new Error('不在app，获取信息失败'))
      return
    }
    window.sui.ready(() => {
      window.sui.getUserInfo({
        needLogin,
        showSkip,
        success: async(res: any) => {
          console.log('loginByGetUserInfo:', res)
          if (res.code !== 0) {
            reject(new Error(res.message || 'getUserInfo登录失败'))
            return
          }
          await store.dispatch('slientLogin')
          resolve(res.result)
        },
        error: (err: any) => {
          console.warn('loginByGetUserInfo error:', err)
          reject(err)
        }
      })
    })
  })
}

export const setDataToClient = () => {
  return new Promise((resolve, reject) => {
    if (!(useragent.isSuishouji || useragent.isKaniu)) {
      reject(new Error('不在随手记app，获取信息失败'))
      return
    }
    window.sui.ready(() => {
      window.sui.setDataToClient({
        type: 'json',
        key: 'purchase_ad_free',
        value: {
          status: true
        },
        success: (res: any) => {
          console.log('setDataToClient:', res)
          if (res.code !== 0) {
            reject(new Error(res.message || '清除缓存接口失败'))
            return
          }
          resolve(true)
        },
        error: () => {
          reject(new Error('清除缓存接口失败'))
        }
      })
    })
  })
}

export const loadRewardVideoAd = (options = {}) => {
  return new Promise((resolve, reject) => {
    if (!(useragent.isSuishouji || useragent.isKaniu)) {
      reject(new Error('不在随手记app，获取信息失败'))
      return
    }
    console.log('loadRewardVideoAd-options', options)
    window.sui.ready(() => {
      window.sui.loadRewardVideoAd({
        params: options,
        // timeout: 1000 * 60 * 5,
        waitUserAction: true,
        success: (res: any) => {
          console.log('loadRewardVideoAd-ok:', res)
          if (res.code !== 0) {
            // reject(new Error(res.message || '视频广告接口失败'))
            reject(res)
            return
          }
          resolve(res.result)
        },
        error: (error: any) => {
          console.error('loadRewardVideoAd-error:', error)
          reject(error)
        }
      })
    })
  })
}

export const updateApp = () => {
  return new Promise((resolve, reject) => {
    window.sui.ready(() => {
      window.sui.updateApp({
        success: (res: any) => {
          console.log('updateApp-ok:', res)
          if (res.code !== 0) {
            reject(new Error(res.message || '升级app失败'))
            return
          }
          resolve(res)
        },
        error: (error: any) => {
          console.error('updateApp-error:', error)
          reject(new Error('升级app失败'))
        }
      })
    })
  })
}
